import { CopyOutlined } from '@ant-design/icons'
import { pick } from 'lodash'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'

import { MenuButton } from '../../../MenuButton'
import { useLinkCardStore } from '../../Store/hooks/useStore'

export const CopyLinkButton = () => {
  const { url, toggleToolbarVisible } = useLinkCardStore(state =>
    pick(state, ['url', 'toggleToolbarVisible'])
  )
  const { message } = useFeedback()

  const handleCopyUrl = () => {
    toggleToolbarVisible(false)
    navigator.clipboard.writeText(url ?? '')
    message.success('复制成功')
  }

  return (
    <MenuButton tooltip='复制' onClick={handleCopyUrl}>
      <CopyOutlined />
    </MenuButton>
  )
}
